import type { ImageRef } from "@@/shared/images/image-ref";
import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";
import type { ProviderId } from "../providers/provider-id";
import type { UserId } from "./user-id";

type UserForProvider = {
    _id: UserId;
    _type: "USER_FOR_PROVIDER";
    _createdAt?: IsoAndUnixTimestamp;
    providerId: ProviderId;
    firstName: string;
    lastName: string;
    image?: ImageRef;
    emailAddress: string;
    phoneNumber: string;
    /**
     * Scopes are used to determine what the user can do.
     * These user-scopes are provider-specific only
     */
    scopes: string[];
};

const userDetailsFactory = (
    params: Except<UserForProvider, "_type">,
): UserForProvider => {
    return {
        ...params,
        _type: "USER_FOR_PROVIDER",
    };
};

export { userDetailsFactory };
export type { UserForProvider };
